import { FetchLicenseDetailsResponse } from 'common/services/api/Licenses/LicenseThunkTypeDefs';
import { dateToFrontEndFormat } from 'common/utils/dateHelpers';

import { PagetitleProps } from './components/LicenseDetailsCustomLabel';

export const RESOURCE_NAMES = {
    licenseId: 'License ID',
    companyKey: 'Company Key',
    billingSystem: 'Billing System',
    billingRecord: 'Billing Record',
    startDate: 'Start Date',
    endDate: 'End Date',
    autoRenew: 'Auto Renew',
    licenseNote: 'License Note'
};

export const _createLicenseDetailsHeaderRowItemsConfig = (
    licenseDetails: FetchLicenseDetailsResponse
): PagetitleProps[][] => {
    return [
        [
            {
                resourceName: RESOURCE_NAMES.licenseId,
                resourceValue: licenseDetails.id ?? '',
                copyToClipboard: true,
            },
            {
                resourceName: RESOURCE_NAMES.companyKey,
                resourceValue: licenseDetails?.companyKey,
                copyToClipboard: true,
            }
        ],
        [
            {
                resourceName: RESOURCE_NAMES.billingSystem,
                resourceValue: licenseDetails?.billingSystemName ?? '',
                copyToClipboard: true,
            },
            {
                resourceName: RESOURCE_NAMES.billingRecord,
                resourceValue: licenseDetails?.billingRecord ?? '',
                copyToClipboard: true,
            }
        ],
        [
            {
                resourceName: RESOURCE_NAMES.startDate,
                resourceValue: dateToFrontEndFormat(licenseDetails?.startDate),
            },
            {
                resourceName: RESOURCE_NAMES.endDate,
                resourceValue: licenseDetails?.endDate === 'None' ?  'None' : dateToFrontEndFormat(licenseDetails.endDate),
                addExtraSpaceBeforeValue: true,
            }
        ],
        [
            {
                resourceName: RESOURCE_NAMES.autoRenew,
                resourceValue: licenseDetails?.licenseAutoRenewal ? 'Yes' : 'No',
            },
            {
                resourceName: RESOURCE_NAMES.licenseNote,
                resourceValue: licenseDetails?.note,
            }
        ]
    ];
};
